import { Layout } from "../components/section";
import { Outlet } from "react-router-dom";
import { PageHeader } from "../components/header";

export const About = () => {
  return (
    <>
      <PageHeader title="Ooasis Overview" />
      <Layout>
        <Outlet />
      </Layout>
    </>
  );
};
